import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useUpdateFaq = () => {
  const { setDataToServer } = useCreate({
    url: 'faqs/update',
    refreshUrl: 'faqs/list',
    onSuccess: () => {
      toast.success("FAQ Updated Successfully", {
        position: "top-right",
        duration: 3000
      });
    },
    onError: (error) => {
      const apiMessage = error?.response?.data?.message;
      toast.error(apiMessage || "Error Updating FAQ", {
        position: "top-right",
        duration: 3000
      });
    }
  });
  
  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useUpdateFaq;
